var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D4E2EF",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 33.5C29.9705 33.5 34 29.339 34 26.5C34 23.661 29.9705 19.5 25 19.5C20.0295 19.5 16 23.664 16 26.5C16 29.336 20.0295 33.5 25 33.5Z",
    stroke: "#4F74EF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.5C25.7956 29.5 26.5587 29.1839 27.1213 28.6213C27.6839 28.0587 28 27.2956 28 26.5C28 25.7044 27.6839 24.9413 27.1213 24.3787C26.5587 23.8161 25.7956 23.5 25 23.5C24.2044 23.5 23.4413 23.8161 22.8787 24.3787C22.3161 24.9413 22 25.7044 22 26.5C22 27.2956 22.3161 28.0587 22.8787 28.6213C23.4413 29.1839 24.2044 29.5 25 29.5Z",
    stroke: "#4F74EF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6318 18.633L20.9288 20.443M30.8123 18.855L29.5148 20.665M25.0043 16.5V19.5",
    stroke: "#4F74EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.63bda78f94fd0a75fb049509d4be4cac.svg";
export { ForwardRef as ReactComponent };